import istor from '../Assets/istor2.png';
import ministor from '../Assets/ministor.png';
import { useState } from 'react';
import { useMediaQuery } from '../useMediaQuery';

const CONTENTS = {
    DEFAULT: {
        title: '\u201cMot de passe\noubli\u00e9\u00a0?\u2026',
        message: 'Indiquez l\u2019adresse email avec laquelle vous\navez cr\u00e9\u00e9 votre compte, vous recevrez un lien\npour r\u00e9initialiser votre mot de passe."',
        short: 'Indiquez l\u2019adresse email avec laquelle vous avez cr\u00e9\u00e9 votre compte, vous recevrez un lien pour r\u00e9initialiser votre mot de passe\u201d',
    },
    SENT: {
        title: '\u201cC\u2019est envoy\u00e9\u00a0!',
        message: 'Si cette adresse correspond \u00e0 un compte,\nvous recevrez un e-mail dans\nquelques instants.\nV\u00e9rifiez aussi vos spams\u00a0!"',
    },
    ERROR: {
        title: '\u201c\u00c9trange\u2026',
        message: 'Une erreur est survenue.\nVeuillez r\u00e9essayer dans quelques\ninstants."',
    },
};

const ForgotPassword = () => {
    const API_BASE_URL = 'https://dev-auth.apps.istor.io';

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('DEFAULT');
    const isMobile = useMediaQuery('(max-width: 750px)');

    const istorContent = CONTENTS[status];

    const emailInput = (
        <input
            id="emaili"
            className="ifield"
            style={{ width: '100%', height: '36px', borderRadius: '10px', padding: '0 15px', fontSize: '13px', fontWeight: '400', backgroundColor: '#FFFFFF', boxSizing: 'border-box' }}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Entrez votre adresse mail"
        />
    );

    const validerButton = (
        <button
            className="connexion"
            type="submit"
            disabled={loading}
            style={{ width: '100%', height: '36px', borderRadius: '10px', color: '#FFFFFF', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '13px', fontWeight: '600', cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.6 : 1 }}
        >
            {loading ? <div className="loading-spinner" /> : 'Valider'}
        </button>
    );

    const successMessage = (
        <div style={{ width: '100%', padding: '14px', background: '#EDFFF4', borderRadius: '10px', fontSize: '13px', fontWeight: '400', color: '#1A7A42', lineHeight: '18px', boxSizing: 'border-box', textAlign: 'center' }}>
            {'E-mail envoyé ! Vérifiez votre boîte de réception.'}
        </div>
    );

    const retourLink = (
        <a href="/" className="retour">
            <span className="retour-circle"><svg style={{ minWidth: '20px' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask-retour-forgot-m" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect x="20" y="20" width="20" height="20" transform="rotate(-180 20 20)" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask-retour-forgot-m)">
                    <path d="M6.5 10L12.453 4L13.5 5.07713L8.61571 10L13.5 14.9229L12.453 16L6.5 10Z" fill="currentColor"/>
                </g>
            </svg>
            </span>
            Revenir à la connexion
        </a>
    );

    if (isMobile) {
        return (
            <form
                onSubmit={handleSubmit}
                style={{
                    width: '330px',
                    height: '517px', maxHeight: 'calc(100dvh - 40px)',
                    boxSizing: 'border-box',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '20px',
                    boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
                    padding: '20px 30px 30px 30px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}
            >
                {/* Haut : mini-mascotte + titre + texte court, aligné à gauche */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <img src={ministor} alt="istor" style={{ width: '60px', height: '60px', borderRadius: '50%', flexShrink: 0 }}/>
                        <div style={{ fontSize: '24px', fontWeight: '600', color: '#173C50', whiteSpace: 'pre-line' }}>{CONTENTS.DEFAULT.title}</div>
                    </div>
                    <div style={{
                        marginTop: '10px',
                        whiteSpace: 'pre-line',
                        fontSize: '13px',
                        fontWeight: '400',
                        color: '#173C50',
                        lineHeight: '19px',
                        textAlign: 'left',
                    }}>{CONTENTS.DEFAULT.short}</div>
                </div>

                {/* Bas : input → 20px → Valider → 126px → Revenir à la connexion */}
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    {status === 'SENT' ? (
                        successMessage
                    ) : (
                        <>
                            {emailInput}
                            <div style={{ marginTop: '20px' }}>{validerButton}</div>
                        </>
                    )}
                    <div style={{ marginTop: '126px', display: 'flex', justifyContent: 'flex-start' }}>{retourLink}</div>
                </div>
            </form>
        );
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            await fetch(`${API_BASE_URL}/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            setStatus('SENT');
        } catch {
            setStatus('ERROR');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div style={{ width: '700px', height: '450px', display: 'flex', overflow: 'hidden', borderRadius: '20px', boxShadow: '0px 10px 40px rgba(0,0,0,0.1)' }}>
            {/* Panneau gauche */}
            <div style={{ height: '100%', width: '360px', backgroundColor: '#173C50', position: 'relative', color: '#FFFFFF', flexShrink: 0 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', paddingLeft: '30px', position: 'absolute', top: '36px' }}>
                    <div style={{ fontSize: '24px', fontWeight: '600', whiteSpace: 'pre-line' }}>{istorContent.title}</div>
                    <div style={{ whiteSpace: 'pre-line', fontSize: '13px', fontWeight: '400', lineHeight: '19px' }}>{istorContent.message}</div>
                </div>
                <img style={{ position: 'absolute', bottom: 0, right: '-20px', width: '325px', height: '260px' }} src={istor} alt="istor" />
            </div>

            {/* Panneau droit */}
            <form
                onSubmit={handleSubmit}
                style={{ width: '340px', height: '100%', backgroundColor: '#FFFFFF', display: 'flex', flexDirection: 'column', padding: '20px 35px 35px 35px', boxSizing: 'border-box' }}
            >
                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    flexShrink: 0,
                }}>
                    <a href="/" className="retour">
                        <span className="retour-circle"><svg style={{
                            minWidth: '20px',
                        }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask-retour-forgot" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                <rect x="20" y="20" width="20" height="20" transform="rotate(-180 20 20)" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask-retour-forgot)">
                                <path d="M6.5 10L12.453 4L13.5 5.07713L8.61571 10L13.5 14.9229L12.453 16L6.5 10Z" fill="currentColor"/>
                            </g>
                        </svg>
                        </span>
                        Revenir à la connexion
                    </a>
                </div>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '14px', width: '100%' }}>
                {status === 'SENT' ? (
                    <div style={{ width: '100%', padding: '14px', background: '#EDFFF4', borderRadius: '10px', fontSize: '13px', fontWeight: '400', color: '#1A7A42', lineHeight: '18px', boxSizing: 'border-box', textAlign: 'center' }}>
                        {'E-mail envoyé\u00a0! Vérifiez votre boîte de réception.'}
                    </div>
                ) : (
                    <>
                        <input
                            id="emaili"
                            className="ifield"
                            style={{ width: '100%', height: '36px', borderRadius: '10px', padding: '0 15px', fontSize: '13px', fontWeight: '400', backgroundColor: '#FFFFFF', boxSizing: 'border-box' }}
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Entrez votre adresse mail"
                        />
                        <button
                            className="connexion"
                            type="submit"
                            disabled={loading}
                            style={{ width: '100%', height: '36px', borderRadius: '10px', color: '#FFFFFF', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '13px', fontWeight: '600', cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.6 : 1 }}
                        >
                            {loading ? <div className="loading-spinner" /> : 'Valider'}
                        </button>
                    </>
                )}
                </div>
            </form>
        </div>
    );
};

export default ForgotPassword;
